const $ = window.jQuery
$().ready(() => {
  const $form = $('[data-form="mtt-departments"]')
  function f () {
    const formData = $form.serializeArray()
    console.log(formData)
    setParameters(formData)
    $('#loader').addClass('show')
    $.ajax(window.main_theme_objects.ajax_url, { data: formData }).done(r => {
      console.log(r)
      $('#loader').removeClass('show')
      if (r.success) {
        $('[data-ajax-id="mtt-departments"]').html(r.data.html)
      } else {
        // todo: display error state
      }
    })
  }

  $('.mtt-departments-filter select').on('change', function () {
    $('#page_number').val(0)
  })

  $form.on('change', f)
  function g () {
    $(document).on('click', '#pagination-next', () => {
      if ($('#pagination-next').attr('aria-disabled')) {
        return
      }
      $('#page_number').val((i, val) => Number(val) + 1).change()
    })
    $(document).on('click', '#pagination-prev', () => {
      if ($('#pagination-prev').attr('aria-disabled')) {
        return
      }
      $('#page_number').val((i, val) => Number(val) - 1).change()
    })
  }
  g()

  function setParameters (formData) {
    for (let i = 0; i < formData.length; i++) {
      const data = formData[i]

      if (data.name !== 'action') {
        insertParam(data.name, data.value)
      }
    }
  }

  function removeURLParameter (url, parameter) {
    // better to use l.search if you have a location/link object
    const urlparts = url.split('?')
    if (urlparts.length >= 2) {
      const prefix = encodeURIComponent(parameter) + '='
      const pars = urlparts[1].split(/[&;]/g)

      // reverse iteration as may be destructive
      for (let i = pars.length; i-- > 0;) {
        // idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1)
        }
      }

      url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '')
      return url
    } else {
      return url
    }
  }

  function insertParam (key, value) {
    if (history.pushState) {
      var currentUrlWithOutHash = window.location.origin + window.location.pathname + window.location.search
      const hash = window.location.hash
      // remove any param for the same key
      var currentUrlWithOutHash = removeURLParameter(currentUrlWithOutHash, key)

      // figure out if we need to add the param with a ? or a &
      let queryStart
      if (currentUrlWithOutHash.indexOf('?') !== -1) {
        queryStart = '&'
      } else {
        queryStart = '?'
      }

      const newurl = currentUrlWithOutHash + queryStart + key + '=' + value + hash
      window.history.pushState({ path: newurl }, '', newurl)
    }
  }
})
